module.exports = __webpack_public_path__ + "img/logo-tatarana-black.34dec32a.svg";